import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "ferrarezi_cookie_consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(STORAGE_KEY);
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleConsent = (value: "accepted" | "rejected") => {
    localStorage.setItem(STORAGE_KEY, value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-3 md:p-4">
      <div className="max-w-2xl mx-auto bg-white border border-gray-200 rounded-lg p-4">
        <div className="flex flex-col gap-3">
          <div className="flex items-start gap-2.5">
            <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#FBC52D] shrink-0">
              <i className="ri-shield-check-line text-black text-sm" />
            </div>
            <p className="text-gray-600 text-xs leading-relaxed">
              Utilizamos cookies para melhorar sua experiência e analisar o tráfego do site. Saiba mais na nossa{" "}
              <Link to="/politica-de-privacidade" className="text-black font-semibold underline hover:text-[#FBC52D] transition-colors cursor-pointer">
                Política de Privacidade
              </Link>
              .
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:justify-end">
            <button
              type="button"
              onClick={() => handleConsent("rejected")}
              className="whitespace-nowrap px-4 py-2 text-xs font-medium text-gray-500 border border-gray-200 rounded-md hover:bg-gray-50 hover:text-black transition-colors cursor-pointer"
            >
              Recusar
            </button>
            <button
              type="button"
              onClick={() => handleConsent("accepted")}
              className="whitespace-nowrap px-4 py-2 text-xs font-semibold text-black bg-[#FBC52D] rounded-md hover:bg-[#e8b41f] transition-colors cursor-pointer"
            >
              Aceitar cookies
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}